import { ContractReminderStatus } from '@gi/enums/contract-reminder-status.enum';

export const CONTRACT_REMINDER_STATUS_LABEL: Record<ContractReminderStatus, string> = {
  [ContractReminderStatus.done]: 'Faite',
  [ContractReminderStatus.todo]: 'À faire',
  [ContractReminderStatus.coming]: 'À venir',
  [ContractReminderStatus.late]: 'En retard'
};
